import React, { useEffect, useRef, useState } from "react";
import AUlinkList from "./link-list";

export const AUmainNavMenu = ({ items = [], linkComponent = "a" }) => (
  <AUlinkList linkComponent={linkComponent} items={items.map(item => ({
    link: item.link, text: item.text,
    "aria-current": item.active ? "page" : undefined,
    li: item.active ? { className: "active" } : undefined
  }))} />
);

let nextId = 0;
export const AUmainNavContent = ({ items = [], children, linkComponent = "a", onOpen, afterOpen, onClose, afterClose }) => {
  const [open, setOpen] = useState(false);
  const id = useRef(`au-main-nav-${++nextId}`);
  const openButton = useRef(null);
  const closeButton = useRef(null);
  useEffect(() => {
    const onKeyDown = event => event.key === "Escape" && setOpen(false);
    if (open) {
      document.addEventListener("keydown", onKeyDown);
      document.body.classList.add("au-main-nav__scroll--locked");
      closeButton.current && closeButton.current.focus();
    }
    return () => {
      document.removeEventListener("keydown", onKeyDown);
      document.body.classList.remove("au-main-nav__scroll--locked");
    };
  }, [open]);
  const toggle = event => {
    event && event.preventDefault();
    const next = !open;
    next ? onOpen && onOpen() : onClose && onClose();
    setOpen(next);
    window.setTimeout(() => {
      next ? afterOpen && afterOpen() : afterClose && afterClose();
      if (!next && openButton.current) openButton.current.focus();
    }, 0);
  };
  return <div id={id.current} className={`au-main-nav__content au-main-nav__content--${open ? "open" : "closed"}`}>
    <button ref={openButton} aria-controls={`${id.current}-menu`} aria-expanded={open} onClick={toggle} className="au-main-nav__toggle au-main-nav__toggle--open">Menu</button>
    <div id={`${id.current}-menu`} className="au-main-nav__menu"><div className="au-main-nav__menu-inner">
      <button ref={closeButton} aria-controls={`${id.current}-menu`} aria-expanded={open} onClick={toggle} className="au-main-nav__toggle au-main-nav__toggle--close">Close</button>
      <AUmainNavMenu linkComponent={linkComponent} items={items} />{children}
    </div></div>
    <button type="button" aria-label="Close menu" onClick={toggle} className="au-main-nav__overlay" />
  </div>;
};

const AUmainNav = ({ dark, alt, className = "", ariaLabel = "main", children, ...attributes }) => (
  <nav className={`au-main-nav${dark ? " au-main-nav--dark" : ""}${alt ? " au-main-nav--alt" : ""} ${className}`} aria-label={ariaLabel} {...attributes}>{children}</nav>
);
export default AUmainNav;
